export default __webpack_public_path__ + "static/media/sectionThree.f2e1770e.jpg";